
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5(010|817|935)|6(351|374|542)|3((14|7|83)9|435|883)|9(288|636|693)|1972|2279|2695|4676|4955|7542|8450)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
